export const AUTOCOMPLETE_DEBOUNCE_TIME = 200
